/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FieldRefDto } from './FieldRefDto';
import type { NestedStringFilterDto } from './NestedStringFilterDto';
export type StringFilterDto = {
  /**
   * Equals filter for string values
   */
  equals?: string | FieldRefDto;
  /**
   * In filter for string values
   */
  in?: Array<string> | FieldRefDto;
  /**
   * Not in filter for string values
   */
  notIn?: Array<string> | FieldRefDto;
  /**
   * Less than filter for string values
   */
  lt?: string | FieldRefDto;
  /**
   * Less than or equal filter for string values
   */
  lte?: string | FieldRefDto;
  /**
   * Greater than filter for string values
   */
  gt?: string | FieldRefDto;
  /**
   * Greater than or equal filter for string values
   */
  gte?: string | FieldRefDto;
  /**
   * Contains filter for string values
   */
  contains?: string | FieldRefDto;
  /**
   * Starts with filter for string values
   */
  startsWith?: string | FieldRefDto;
  /**
   * Ends with filter for string values
   */
  endsWith?: string | FieldRefDto;
  /**
   * Query mode for case sensitivity
   */
  mode?: StringFilterDto.mode;
  /**
   * Not filter for string values
   */
  not?: string | NestedStringFilterDto;
};
export namespace StringFilterDto {
  /**
   * Query mode for case sensitivity
   */
  export enum mode {
    DEFAULT = 'default',
    INSENSITIVE = 'insensitive',
  }
}
